import Enum from '@square/dashboard-utilities/utils/enum';
import { t } from 'i18n';
export const ConnectorType = new Enum(['AND', 'OR', 'ANDOR']);

/**
@method toSentence
@param {Array<string>} inputArray - A list of strings to join.
@param {Object} i18n - The i18n service for translations.
@param {{connector: ConnectorType, softLimit: Number}} options - Parameters for
    customizing the return string. Options include:
  useOrConnector: Used to select the string that joins the final item in the
    list.
  softLimit: Sets a limit of the number of items to be displayed. Additional
    items are displayed as "and X more". If there is only one item over the
    limit, include that in the sentence rather than show "and 1 more".

@returns {string} - The strings from inputArray joined by a separator and a
  final word joiner.
*/
export default function toSentence(inputArray,
// eslint-disable-next-line unicorn/no-object-as-default-parameter
options = {
  connector: ConnectorType.AND
}) {
  let connectors = null;
  switch (options.connector) {
    case ConnectorType.OR:
      connectors = {
        words: t('common.toSentence.wordsConnectorOr'),
        twoWords: t('common.toSentence.twoWordsConnectorOr'),
        lastWord: t('common.toSentence.lastWordConnectorOr')
      };
      break;
    case ConnectorType.ANDOR:
      connectors = {
        words: t('common.toSentence.wordsConnectorAndOr'),
        twoWords: t('common.toSentence.twoWordsConnectorAndOr'),
        lastWord: t('common.toSentence.lastWordConnectorAndOr')
      };
      break;
    case ConnectorType.AND: // fallthrough
    default:
      connectors = {
        words: t('common.toSentence.wordsConnector'),
        twoWords: t('common.toSentence.twoWordsConnector'),
        lastWord: t('common.toSentence.lastWordConnector')
      };
      break;
  }
  if (!inputArray) {
    return '';
  }
  switch (inputArray.length) {
    case 0:
      return '';
    case 1:
      return inputArray[0];
    case 2:
      return inputArray[0] + connectors.twoWords + inputArray[1];
    default:
      {
        let inputArrayCopy;
        let lastWord;
        if (options.softLimit && inputArray.length > options.softLimit + 1) {
          inputArrayCopy = inputArray.slice(0, options.softLimit);
          return inputArrayCopy.join(connectors.words) + connectors.lastWord + t('common.toSentence.wordsRemaining', {
            count: inputArray.length - options.softLimit
          });
        } else {
          inputArrayCopy = inputArray.slice(0, -1);
          lastWord = inputArray[inputArray.length - 1];
          return inputArrayCopy.join(connectors.words) + connectors.lastWord + lastWord;
        }
      }
  }
}